export enum SideHiddenTabs {
  Conditions,
  Settings,
  Comments
}
